<template>
  <div class="bg-red-500 p">
    <nav class="nav">
      <div class="nav-box">
        <div
          class="nav-box_item text-ellipsis"
          v-for="(item, index) in routerList"
          :key="item.columnName"
          :class="{ 'nav-box_active': routerPath === item.columnCode }"
          @click="goList(item, index)"
        >
          {{ item.columnName }}
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { getNav } from '@/api';
export default {
  data() {
    return {
      isSticky: false, //是否吸顶
      navHeight: 0, // nav的高度
      conScrollTop: 0, // 容器滚动条距离顶部高度
      thatOffsetTop: 0, // 当前组件距离顶部高度
      routerPath: this.$store.state.routerPath,
      routerList: [],
    };
  },
  watch: {
    '$store.state.routerPath'(curVal, oldVal) {
      if (curVal) {
        this.routerPath = curVal;
      }
    },
  },
  mounted() {
    this.getNav();
  },
  methods: {
    goList(item, index) {
      this.$store.commit('SET_ROUTER_INDEX', item.columnCode);
      this.$router.push({
        path: item.linkUrl,
        query: { type: item.columnCode, name: item.columnName },
      });
    },
    async getNav() {
      const { code, result } = await getNav();
      this.routerList = [
        {
          columnCode: 'home',
          columnName: '首页',
          linkUrl: '/home',
        },
        ...result,
      ];
      this.$store.commit('SET_ROUTER_INDEX', this.$route.query.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  margin: 0 auto;
  background: #e60012;
  color: #fff;
  &-box {
    margin: 0 auto;
    width: 1200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &_item {
      display: inline-block;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background: #cf0010;
      }
    }
    &_active {
      background: #cf0010;
    }
  }
}
</style>
